module.exports = __webpack_public_path__ + "img/photo-19.d1084977.jpg";